export const TelegramIcon = () => {
    return (
        <>
            <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 512 512"
                style={{ enableBackground: 'new 0 0 512 512' }}
            >
                <circle style={{ fill: '#7AA5DA' }} cx="256" cy="256" r="256" />
                <path
                    style={{ fill: '#5786B5' }}
                    d="M511.924,250.077L398.283,136.625l-185.108,225.63l133.284,133.284
	C443.197,458.988,512,365.535,512,256C512,254.019,511.969,252.045,511.924,250.077z"
                />
                <path
                    style={{ fill: '#FFFFFF' }}
                    d="M383.717,133.52c10.206-3.982,20.756,4.948,18.515,15.67l-45.77,218.781
	c-2.138,10.257-14.188,14.877-22.635,8.671l-69.094-50.717l-35.219,35.961c-6.189,6.31-16.86,3.741-19.515-4.672l-25.41-80.662
	l-68.112-20.118c-8.947-2.638-9.464-15.084-0.793-18.48L383.717,133.52z M350.118,182.065c2.982-2.638-0.483-7.292-3.862-5.189
	l-147.015,91.177c-2.586,1.603-3.775,4.758-2.862,7.671l20.049,88.04c0.397,1.345,2.327,1.155,2.5-0.241l4.482-67.094
	c0.172-1.655,0.965-3.172,2.207-4.275L350.118,182.065z"
                />
                <path
                    style={{ fill: '#9EC2E5' }}
                    d="M346.257,176.876c3.379-2.103,6.844,2.551,3.862,5.189l-124.5,110.089
	c-1.241,1.103-2.034,2.62-2.207,4.275l-4.482,67.094c-0.172,1.396-2.103,1.586-2.5,0.241l-20.049-88.04
	c-0.914-2.913,0.276-6.068,2.862-7.671L346.257,176.876z"
                />
                <path
                    style={{ fill: '#FFFFFF' }}
                    d="M217.154,364.678c-3.241-1.155-5.982-3.741-7.154-7.465l-25.41-80.662l-68.112-20.118
	c-8.947-2.638-9.464-15.084-0.793-18.48L383.717,133.52c6.585-2.569,13.326,0.241,16.653,5.448
	c-0.621-0.948-1.362-1.827-2.189-2.603L216.343,284.81v6.499l-1-0.724l1,40.926v32.823c0.259,0.121,0.534,0.224,0.81,0.31V364.678
	L217.154,364.678z"
                />
                <g>
                    <path
                        style={{ fill: '#D1D1D1' }}
                        d="M402.525,145.518c0.052,1.172-0.034,2.413-0.293,3.672l-45.77,218.781
		c-2.138,10.257-14.188,14.877-22.635,8.671l-69.094-50.717l-48.39-34.616v-6.499l181.838-148.446
		c0.827,0.776,1.569,1.655,2.189,2.603c0.121,0.207,0.241,0.396,0.362,0.586c0.103,0.207,0.224,0.414,0.328,0.603
		c0.103,0.207,0.207,0.414,0.293,0.621c0.103,0.224,0.19,0.431,0.276,0.655c0.069,0.19,0.155,0.396,0.224,0.621
		c0.224,0.672,0.396,1.362,0.517,2.086C402.439,144.587,402.491,145.036,402.525,145.518z"
                    />
                    <path
                        style={{ fill: '#D1D1D1' }}
                        d="M264.733,325.925l-35.219,35.961c-0.293,0.293-0.603,0.586-0.914,0.845
		c-0.31,0.259-0.621,0.483-0.948,0.707c-0.017,0.017-0.017,0.017-0.017,0.017c-0.655,0.431-1.327,0.793-2.034,1.086
		c-0.362,0.138-0.707,0.276-1.069,0.362c-1.5,0.448-3.034,0.569-4.551,0.414c-0.396-0.034-0.793-0.103-1.172-0.172
		c-0.052,0-0.103-0.017-0.155-0.034c-0.379-0.103-0.759-0.207-1.138-0.328c-0.121-0.034-0.241-0.069-0.362-0.138l-0.81-33.133
		v-40.202L264.733,325.925z"
                    />
                </g>
                <g>
                    <path
                        style={{ fill: '#DADDE0' }}
                        d="M228.6,362.73c-0.31,0.259-0.621,0.5-0.948,0.724v-0.017
		C227.98,363.213,228.29,362.989,228.6,362.73z"
                    />
                    <path
                        style={{ fill: '#DADDE0' }}
                        d="M227.652,363.437v0.017c0,0,0-0.017-0.017,0C227.635,363.454,227.635,363.454,227.652,363.437z"
                    />
                    <path
                        style={{ fill: '#DADDE0' }}
                        d="M225.601,364.541c0.707-0.293,1.379-0.655,2.034-1.086
		C226.98,363.885,226.29,364.247,225.601,364.541z"
                    />
                    <path
                        style={{ fill: '#DADDE0' }}
                        d="M219.981,365.316c1.517,0.155,3.051,0.034,4.551-0.414c-1.086,0.345-2.207,0.5-3.327,0.5
		c-0.345,0-0.69-0.017-1.017-0.052C220.119,365.351,220.05,365.351,219.981,365.316z"
                    />
                </g>
                <g>
                    <path
                        style={{ fill: '#FFFFFF' }}
                        d="M221.205,365.402c-0.345,0-0.69-0.017-1.017-0.052C220.515,365.385,220.86,365.402,221.205,365.402z
		"
                    />
                    <path
                        style={{ fill: '#FFFFFF' }}
                        d="M219.981,365.316c0.069,0.034,0.138,0.034,0.207,0.034c-0.362-0.017-0.69-0.069-1.034-0.138
		C219.429,365.265,219.705,365.299,219.981,365.316z"
                    />
                </g>
                <g>
                    <path
                        style={{ fill: '#DADDE0' }}
                        d="M219.981,365.316c-0.276-0.017-0.552-0.052-0.827-0.103c-0.121-0.017-0.241-0.034-0.345-0.069
		C219.188,365.213,219.584,365.282,219.981,365.316z"
                    />
                    <path
                        style={{ fill: '#DADDE0' }}
                        d="M217.516,364.782c0.379,0.121,0.759,0.224,1.138,0.328c-0.155-0.034-0.31-0.069-0.465-0.103
		c-0.069-0.017-0.138-0.034-0.19-0.069C217.843,364.903,217.671,364.851,217.516,364.782z"
                    />
                </g>
                <g>
                    <path
                        style={{ fill: '#FFFFFF' }}
                        d="M218.188,365.006c0.155,0.034,0.31,0.069,0.465,0.103
		C218.498,365.092,218.343,365.058,218.188,365.006z"
                    />
                    <path
                        style={{ fill: '#FFFFFF' }}
                        d="M217.516,364.782c0.155,0.069,0.328,0.121,0.483,0.155c-0.259-0.052-0.517-0.138-0.776-0.241
		C217.326,364.73,217.412,364.765,217.516,364.782z"
                    />
                </g>
                <path
                    style={{ fill: '#DADDE0' }}
                    d="M217.516,364.782c-0.103-0.017-0.19-0.052-0.293-0.086c-0.017,0.017-0.052,0-0.069-0.017v-0.034
	C217.274,364.713,217.395,364.747,217.516,364.782z"
                />
                <path
                    style={{ fill: '#D1D1D1' }}
                    d="M216.343,331.511l0.81,33.133c-0.276-0.086-0.552-0.19-0.81-0.31V331.511z"
                />
                <polygon style={{ fill: '#DADDE0' }} points="216.343,291.309 216.343,331.511 215.343,290.585 " />
                <path
                    style={{ fill: '#ADBCC9' }}
                    d="M350.118,182.065l-124.5,110.089c-1.241,1.103-2.034,2.62-2.207,4.275l-4.474,67.1
	c-0.172,1.396-2.103,1.586-2.517,0.241l-20.04-88.045c-0.914-2.913,0.276-6.068,2.862-7.671l147.015-91.177
	C349.636,174.773,353.101,179.428,350.118,182.065z"
                />
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
            </svg>
        </>
    );
};
